import getCookie from './getCookie'
import setLongLastingCookie from './setLongLastingCookie'

// TODO: change CookieSettingsInputs.php to add default cookies instead of initializing them here
export default function setUpSettingsCookies () {
  // Set tutorial to true if user is new.
  if (getCookie('is_tutorial_active') === '') setLongLastingCookie('is_tutorial_active', false)
  if (getCookie('show_barcode_sku') === '') setLongLastingCookie('show_barcode_sku', true)
}
